module.exports = __webpack_public_path__ + "static/media/image_phone.4486c530.png";